import {
  getFavorites
} from "./chunk-OWEMZM5M.js";
import {
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/getFavorites/getFavorites.ts
async function getFavorites2(apiConfig) {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
    );
  }
  try {
    const response = await getFavorites(apiConfig);
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  getFavorites2 as getFavorites
};
